import React from 'react';
import { Section } from 'shared/ui/Section';
import { Picker } from 'shared/ui/Picker';
import { Figure } from 'shared/ui/Figure';
import { useReportSectionStatus } from 'shared/state/sectionStatusContext';
import { useNetworkingSection } from './useNetworkingSection';

export function NetworkingSection({ id }: { id: string }) {
  const s = useNetworkingSection();
  useReportSectionStatus(id, s.status);
  return (
    <Section.Root id={id} defaultOpen>
      <Section.Bar title="Networking" role="Interface" summary={s.summary} />
      <Section.Body>
        <div className="grid gap-4 md:grid-cols-3">
          <Picker id="interface" label="Network Interface"
            options={s.interfaceOptions} value={s.interfaceOption} onChange={s.onInterfaceChange} />
          <Picker id="protocol" label="Network Protocol"
            options={s.protocolOptions} value={s.networkProtocol} onChange={s.onProtocolChange} />
          <Figure label="Network Ports" value={<span data-testid="network-ports">{s.networkPorts}</span>} />
        </div>
      </Section.Body>
    </Section.Root>
  );
}
